import type { WalletDetailsFilterItemProps } from './WalletDetailsFilter.types';
import type { ReactElement } from 'react';

import { Button, Popover, Text } from '@rango-dev/whale';
import { ChevronDown } from 'lucide-react';
import React from 'react';

import styles from './WalletDetailsFilter.module.css';

const CHEVRON_SIZE = 16;
const POPOVER_WIDTH = '280px';

export function WalletDetailsFilterItem(props: WalletDetailsFilterItemProps): ReactElement {
  const { id, label, isFiltered, popoverAlign, content, isMobile, open, onOpenChange } = props;

  const trigger = (
    <Button
      id={id}
      size={{ initial: '2', sm: '3' }}
      variant="surface"
      color="gray"
      className={styles.trigger}
      onClick={isMobile ? () => onOpenChange(true) : undefined}>
      <Text
        size="3"
        truncate
        className={isFiltered ? styles.triggerLabelActive : styles.triggerLabel}>
        {label}
      </Text>
      <span className={styles.triggerChevron} aria-hidden>
        <ChevronDown size={CHEVRON_SIZE} />
      </span>
    </Button>
  );

  if (isMobile) {
    return trigger;
  }

  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <Popover.Trigger>{trigger}</Popover.Trigger>
      <Popover.Content
        size="2"
        align={popoverAlign}
        width={POPOVER_WIDTH}
        className={styles.popover}>
        {content}
      </Popover.Content>
    </Popover.Root>
  );
}
